import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV === 'production') {
  // Disable console logs in production
  console.log = function() {};
  console.warn = function() {};
  // console.error = function() {};
}
 if (process.env.NODE_ENV === 'development') {
   // Disable console logs in development
  //  console.log = function() {};
   console.warn = function() {};
  //  console.error = function() {};
 }
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
